import React from "react";
import logo from "../assets/spacem8-logo.png";

export default function Footer({ isDark }) {
  return (
    <footer
      className={`w-full rounded-3xl border px-6 py-6 shadow-xl backdrop-blur ${
        isDark
          ? "border-slate-800 bg-slate-900/95"
          : "border-slate-200 bg-white/95"
      }`}
    >
      <div className="mb-5 h-[1px] bg-gradient-to-r from-transparent via-sky-400/40 to-transparent" />

      <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-center gap-3">
          <img
            src={logo}
            alt="SpaceM8"
            className="h-10 w-auto object-contain"
          />

          <div>
            <p
              className={`text-sm font-semibold ${
                isDark ? "text-white" : "text-slate-900"
              }`}
            >
              SpaceM8
            </p>
            <p className="text-xs font-medium text-sky-600">
              Where Property Meets Intelligence
            </p>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
  <a
    href="/properties"
    className={`text-sm transition hover:text-sky-600 ${
      isDark ? "text-slate-300" : "text-slate-600"
    }`}
  >
    Properties
  </a>

  <a
    href="/privacy"
    className={`text-sm transition hover:text-sky-600 ${
      isDark ? "text-slate-300" : "text-slate-600"
    }`}
  >
    Privacy Policy
  </a>

  <a
    href="/terms"
    className={`text-sm transition hover:text-sky-600 ${
      isDark ? "text-slate-300" : "text-slate-600"
    }`}
  >
    Terms
  </a>

  <a
    href="/contact"
    className={`text-sm transition hover:text-sky-600 ${
      isDark ? "text-slate-300" : "text-slate-600"
    }`}
  >
    Contact
  </a>
</div>

        <div className="text-left lg:text-right">
          <p
            className={`text-xs ${
              isDark ? "text-slate-400" : "text-slate-500"
            }`}
          >
            A product of
          </p>

          <a
            href="https://www.jisedai.africa"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-semibold text-yellow-500 transition hover:text-orange-500"
          >
            Jised-AI
          </a>
        </div>
      </div>

      <div
        className={`mt-6 flex flex-col gap-3 border-t pt-4 text-xs md:flex-row md:items-center md:justify-between ${
          isDark ? "border-slate-800" : "border-slate-200"
        }`}
      >
        <p className={isDark ? "text-slate-400" : "text-slate-500"}>
          © {new Date().getFullYear()} SpaceM8. All rights reserved.
        </p>

        <div className="flex items-center gap-3">
          <span
            className={`rounded-full px-2.5 py-1 ${
              isDark
                ? "bg-slate-800 text-slate-300"
                : "bg-slate-100 text-slate-600"
            }`}
          >
            v1.0 • SpaceM8 Core
          </span>

          <span className="inline-flex items-center gap-2 text-emerald-500">
            <span className="h-2 w-2 rounded-full bg-emerald-500" />
            System Online
          </span>
        </div>
      </div>
    </footer>
  );
}
